module.exports = __webpack_public_path__ + "img/IMG_9786_L_Black_MockedUp.a7e9a698.jpg";